import * as React from 'react';
import { IRestriction } from '../models';
import { useData } from '../core/context/ProvidersContext';

export function useRestrictions(): {
  restrictions: IRestriction[];
  loading: boolean;
  error: string | null;
  refresh: () => void;
} {
  const data = useData();
  const [restrictions, setRestrictions] = React.useState<IRestriction[]>([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState<string | null>(null);

  const refresh = React.useCallback(() => {
    setLoading(true);
    setError(null);
    data.getRestrictions()
      .then(setRestrictions)
      .catch((err: Error) => setError(err.message))
      .finally(() => setLoading(false));
  }, [data]);

  React.useEffect(() => { refresh(); }, [refresh]);

  return { restrictions, loading, error, refresh };
}
